module.exports = __webpack_public_path__ + "static/media/B4.0098850b.webp";